import React from 'react';
import { SvgIcon } from '@mui/material';

export const CloseIcon = ({ color, ...props }) => (
  <SvgIcon {...props}>
    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill={ color } fillRule="evenodd"/>
  </SvgIcon>
);
